// Mapeo categoría de negocio -> ID de product_cat en WooCommerce
export const CATEGORIAS_WOO = {
  "Seminueva": 14,
  "Nueva": 828,
};